<template>
  <div class="mb-5">
    <ComboBoxInput
      v-model:model-value="object_type"
      :items="utils.SortedObjectTypes()"
      name="object_type"
      classes="w-full relative dark:text-white opacity-0"
      label-attr="label"
      value-attr="type"
      :is-box-background="true"
      :label="$t('Object Type')"
      :tooltip-info="$t('Select object type here')"
      :show-label="false"
      :floating-label="true"
      :allow-null="false" />

    <div class="h-[400px] overflow-auto overflow-x-hidden mt-6">
      <AdvancedMetricsFilterForm
        v-if="show_filter"
        :result-references="previousLabels"
        :record-filter="true"
        :initial-filter="filter"
        :object-type="object_type"
        @update="handleUpdateFilter" />
    </div>
  </div>
</template>

<script>
import AdvancedMetricsFilterForm from "@/components/forms/AdvancedMetricsFilterForm.vue"
import ComboBoxInput from "@/components/shared/ComboBoxInput.vue"
import { transformMetricFilterToServerFilter } from "@/services/data.transformers"
import { utils } from "@/store/helpers"

export default {
  components: {
    ComboBoxInput,
    AdvancedMetricsFilterForm
  },
  props: { selectedNode: null, previousLabels: null },
  emits: ["updateValues"],

  data() {
    return {
      utils,
      filter: "",
      object_type: "company",
      prevent_watch: false,
      show_filter: false
    }
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        if (!this.prevent_watch) {
          this.handleUpdateValues()
        }
      }
    }
  },
  created() {
    setTimeout(() => {
      this.init()
      this.show_filter = true
    }, 100)
  },

  methods: {
    handleUpdateFilter(filter) {
      const filter_cleaned = []
      filter.forEach((item) => {
        if (item.data_type == "String") {
          if (Array.isArray(item.value)) {
            item.value = String(item.value)
          }
          // let value = item.value.replace(/[']+/g, "")
          filter_cleaned.push({ ...item, value: item.value == null ? "" : item.value.trim() })
        } else {
          if (
            item.value == null ||
            item.value == undefined ||
            item.value == "" ||
            item.value == "null" ||
            item.value == "undefined" ||
            item.value == "None"
          ) {
            item.value = null
          } else if (
            (item.data_type == "Date" || item.data_type == "DateTime") &&
            !(
              item.operator.value == "__DAYS_WITHIN_LAST_X_DAYS__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_AGO__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_AGO__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_FROM_NOW__" ||
              item.operator.value == "__DAYS_WITHIN_NEXT_X_DAYS__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_FROM_NOW__"
            )
          ) {
            item.value = this.$moment(item.value).format("YYYY-MM-DD")
          } else if (
            item.data_type == "DateTime" &&
            !(
              item.operator.value == "__DAYS_WITHIN_LAST_X_DAYS__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_AGO__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_AGO__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_FROM_NOW__" ||
              item.operator.value == "__DAYS_WITHIN_NEXT_X_DAYS__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_FROM_NOW__"
            )
          ) {
            item.value = this.$moment(item.value).format("YYYY-MM-DDTHH:mm:ss")
          }
          filter_cleaned.push({ ...item, value: item.value })
        }
      })
      let parsed_filter = transformMetricFilterToServerFilter([...filter_cleaned])

      if (!this.prevent_watch) {
        this.filter = parsed_filter.filter
      }

      this.handleUpdateValues()
    },

    handleUpdateValues() {
      const data = {
        ...this.selectedNode.data.values,
        valid: true,
        object_type: this.object_type,
        filter: this.filter
      }

      this.$emit("updateValues", data)
    },
    init() {
      this.prevent_watch = true

      if (!this.selectedNode.data.values.filter && this.previousLabels.length) {
        this.filter = `( id == '\${${this.previousLabels[0].name.toLowerCase().replaceAll(" ", "_")}.id}' )`
      } else {
        this.filter = this.$utils.clone(this.selectedNode.data.values.filter)
      }

      if (this.selectedNode.data.values.object_type) {
        this.object_type = this.selectedNode.data.values.object_type
      }
      setTimeout(() => {
        this.prevent_watch = false
      }, 600)
    }
  }
}
</script>
